import { render } from "./portnavbar.vue?vue&type=template&id=dd6e74ca&scoped=true"
import script from "./portnavbar.vue?vue&type=script&lang=js"
export * from "./portnavbar.vue?vue&type=script&lang=js"

import "./portnavbar.vue?vue&type=style&index=0&id=dd6e74ca&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\juani\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd6e74ca"]])

export default __exports__